export default function AquacultureSystem() {
  const systemFeatures = [
    {
      icon: 'ri-water-flash-line',
      title: '閉鎖循環型システム',
      description: '水を循環利用することで、使用量を従来の1/10以下に削減',
      impact: '90%以上の水使用量削減'
    },
    {
      icon: 'ri-leaf-line',
      title: 'ゼロエミッション',
      description: '排水による環境汚染をゼロに。地域の水環境を守ります',
      impact: '環境排水ゼロ'
    },
    {
      icon: 'ri-temp-cold-line',
      title: '温度管理システム',
      description: '最適な水温を年間通じて維持し、安定した生産を実現',
      impact: '年間安定生産'
    },
    {
      icon: 'ri-shield-check-line',
      title: '病気リスク低減',
      description: '閉鎖環境により外部からの病原体侵入を防止',
      impact: '健康な養殖環境'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/065291f33252c92281e7e36737e4f0d1.jpg"
                alt="筑波大学の循環型陸上養殖システム"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border border-[#E8F5E9]">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center">
                  <i className="ri-microscope-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 whitespace-nowrap">技術提供</p>
                  <p className="font-semibold text-[#1A2332]">筑波大学</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
              <i className="ri-flask-line text-[#2D7A3E] text-lg mr-2"></i>
              <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">先進技術の活用</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
              筑波大学の<br />
              研究技術を導入
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              筑波大学生命環境系 名誉教授 張振亜教授が開発した閉鎖循環型陸上養殖システムを採用。環境負荷を最小限に抑えながら、高品質な水産物を安定的に生産します。
            </p>
            <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9] mb-6">
              <div className="flex items-start mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 flex-shrink-0 bg-gray-200">
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-user-line text-gray-500 text-xl"></i>
                  </div>
                </div>
                <div>
                  <p className="font-semibold text-[#1A2332] mb-1">張振亜 名誉教授</p>
                  <p className="text-sm text-gray-600">筑波大学 生命環境系</p>
                  <p className="text-sm text-gray-600 mt-2">技術顧問として本プロジェクトを支援</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {systemFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9] hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2332] mb-3">{feature.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{feature.description}</p>
              <div className="pt-4 border-t border-[#C8E6C9]">
                <p className="text-sm font-semibold text-[#2D7A3E]">{feature.impact}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#2D7A3E] to-[#4CAF50] p-10 rounded-2xl text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">持続可能な食料生産を実現</h3>
            <p className="text-lg mb-8 leading-relaxed opacity-95">
              この技術により、環境に配慮しながら安定した水産物の生産が可能になります。地域の新しい産業として、持続可能な食料供給に貢献します。
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div>
                <p className="text-4xl font-bold mb-2">1/10</p>
                <p className="text-sm opacity-90">水使用量</p>
              </div>
              <div>
                <p className="text-4xl font-bold mb-2">365日</p>
                <p className="text-sm opacity-90">安定生産</p>
              </div>
              <div>
                <p className="text-4xl font-bold mb-2">0kg</p>
                <p className="text-sm opacity-90">環境排水</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}